"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumborBackgroundColor = exports.ThumborFillColor = exports.ThumborFit = void 0;
var ThumborFit;
(function (ThumborFit) {
    ThumborFit["IN"] = "fit-in";
    ThumborFit["FULL_IN"] = "full-fit-in";
    ThumborFit["ADAPTIVE"] = "adaptive-fit-in";
    ThumborFit["NONE"] = "";
})(ThumborFit = exports.ThumborFit || (exports.ThumborFit = {}));
var ThumborFillColor;
(function (ThumborFillColor) {
    ThumborFillColor["BLUR"] = "blur";
    ThumborFillColor["AUTO"] = "auto";
    ThumborFillColor["WHITE"] = "white";
    ThumborFillColor["BLACK"] = "black";
})(ThumborFillColor = exports.ThumborFillColor || (exports.ThumborFillColor = {}));
var ThumborBackgroundColor;
(function (ThumborBackgroundColor) {
    ThumborBackgroundColor["WHITE"] = "white";
    ThumborBackgroundColor["BLACK"] = "black";
})(ThumborBackgroundColor = exports.ThumborBackgroundColor || (exports.ThumborBackgroundColor = {}));
//# sourceMappingURL=types.js.map